(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('Handbook', Handbook);

    Handbook.$inject = ['$resource'];

    function Handbook ($resource) {
        var resourceUrl =  'api/handbooks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
